import template from "./bD365Menu.html";

export function bD365MenuDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bD365MenuController,
    controllerAs: 'bD365Menu',
    bindToController: true,
    scope: {
      clients: "=",
      processGroupsConfig: "=",
      interrupts: "="
    }
  };

  return directive;
}

class bD365MenuController {
  constructor() {
    'ngInject';
  }

  back() {
    window.close();
  }
}